import * as rtk from "@reduxjs/toolkit";
import "../api/email-detection.js";
import { loginApi } from "../api/login.js";
import { registrationApi, createPassword } from "../api/registration.js";
import { userApi } from "../api/user.js";
import { GenericError } from "../api/user-types.js";
import { getIsModalVisible } from "../store/state/getters.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@crystal/core";
import { openModal, closeModal } from "../store/state/triggers.js";
import { beforeAuthenticationSuccess } from "./utils.js";
const { createAction, createAsyncThunk } = { ...rtk }.default || rtk;
const getProfileDataAction = createAsyncThunk(
  "account/getProfileData",
  (_arg, { rejectWithValue }) => userApi.getProfileData().catch(rejectWithValue),
  {
    condition: (_arg, { getState }) => {
      const { accountPortal } = getState();
      return Boolean(accountPortal == null ? void 0 : accountPortal.isAuthenticated);
    }
  }
);
const registrationApiAction = createAsyncThunk(
  "account/registration",
  async (data, { rejectWithValue }) => {
    return registrationApi.registerUser(data).then((user) => beforeAuthenticationSuccess.emit(user)).catch(rejectWithValue);
  }
);
const lightRegistrationApiAction = createAsyncThunk(
  "account/lightRegistration",
  (data, { rejectWithValue }) => {
    return registrationApi.registerLightUser(data).catch(rejectWithValue);
  }
);
const loginApiAction = createAsyncThunk(
  "account/login",
  (arg, { rejectWithValue }) => {
    return loginApi.login(arg.credentials).then((user) => beforeAuthenticationSuccess.emit(user)).catch(rejectWithValue);
  }
);
const sessionReloadApiAction = createAsyncThunk(
  "account/sessionReload",
  ({ logoutIfUnauthenticated }, { dispatch, rejectWithValue }) => {
    return userApi.reloadSession().catch(async (err) => {
      if (logoutIfUnauthenticated) {
        await dispatch(logoutApiAction());
      }
      let error = err;
      if (!err || !("serialize" in err)) {
        error = new GenericError((err == null ? void 0 : err.message) || "Unknown error", err);
      }
      return rejectWithValue(error.serialize());
    });
  }
);
const externalAuthSuccessAction = createAsyncThunk(
  "account/externalAuthSuccessAction",
  (data, { rejectWithValue }) => {
    var _a;
    if (!data.user) {
      return data;
    }
    if ((_a = data.authContext) == null ? void 0 : _a.appRedirect) {
      return data;
    }
    return beforeAuthenticationSuccess.emit(data.user).then(() => data).catch(rejectWithValue);
  }
);
const createPasswordApiAction = createAsyncThunk(
  "account/create-password",
  (body, { rejectWithValue }) => {
    return createPassword(body).then((user) => beforeAuthenticationSuccess.emit(user)).catch(rejectWithValue);
  }
);
const passwordResetStartApiAction = createAsyncThunk(
  "account/passwordResetStart",
  async (body, { rejectWithValue }) => {
    return userApi.startPasswordReset(body.email).catch(rejectWithValue);
  }
);
const passwordResetCompleteAction = createAsyncThunk(
  "account/passwordResetCompleteAction",
  async (user, { rejectWithValue }) => {
    return beforeAuthenticationSuccess.emit(user).catch(rejectWithValue);
  }
);
const logoutApiAction = createAsyncThunk("account/logout", async () => {
  return userApi.logout().catch(() => {
  }).finally(() => {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.clear();
    }
    if (typeof localStorage !== "undefined") {
      localStorage.clear();
    }
  });
});
const portalModalId = "account-portal-modal";
const portalZIndex = 0;
const portalOpenAction = createAsyncThunk("account/openAccountPortal", (_, { getState }) => {
  openModal(portalModalId, portalZIndex);
  return getIsModalVisible(portalModalId)(getState());
});
const portalCloseAction = createAsyncThunk("account/closeAccountPortal", (_, { getState }) => {
  closeModal(portalModalId);
  const state = getState();
  return getIsModalVisible(portalModalId)(state);
});
const pageContextAction = createAction("account/pageContextAction");
const authContextAction = createAction("account/authContextAction");
const runtimeInfoAction = createAction("account/runtimeInfoAction");
const updateUserAction = createAction("account/updateUserAction");
const externalAuthStartedAction = createAction("account/externalAuthStartedAction");
const externalAuthUpdateAction = createAction("account/externalAuthUpdateAction");
const externalAuthResetAction = createAction("account/externalAuthResetAction");
const externalAuthErrorAction = createAction("account/externalAuthErrorAction");
export {
  authContextAction,
  createPasswordApiAction,
  externalAuthErrorAction,
  externalAuthResetAction,
  externalAuthStartedAction,
  externalAuthSuccessAction,
  externalAuthUpdateAction,
  getProfileDataAction,
  lightRegistrationApiAction,
  loginApiAction,
  logoutApiAction,
  pageContextAction,
  passwordResetCompleteAction,
  passwordResetStartApiAction,
  portalCloseAction,
  portalOpenAction,
  registrationApiAction,
  runtimeInfoAction,
  sessionReloadApiAction,
  updateUserAction
};
//# sourceMappingURL=actions.js.map
